import Assert from "tbAssert";

function buildDependencyList(dependencyLists) {

    let dependencySet = new Set();

    Assert.StrictAssert((dependencyLists != null), "Assertion Failure: Dependency List Builder missing dependency lists parameter");
    dependencyLists.forEach((dependencyList) => {
        Assert.StrictAssert((dependencyList != null), "Assertion Failure: Null or Undefined Dependency List Passed To Dependency List Builder");

        if (typeof dependencyList === "string") {
            //Its not actually a dependency list, but a single dependency entry
            dependencySet.add(dependencyList);
        }
        else {
            dependencyList.forEach((dependency) => {
                Assert.StrictAssert((dependency != null), "Assertion Failure: Null or Undefined Dependency Entry");
                dependencySet.add(dependency);
            });
        }

    });
    
    let builtDependencyList = Array.from(dependencySet.values());
    return builtDependencyList;
}

export default buildDependencyList;



//////////////////
// WEBPACK FOOTER
// ./src/utility/DependencyListBuilder.js
// module id = P6gZ
// module chunks = 1